export default __webpack_public_path__ + "static/media/relationship_information.8498c91c.svg";